const PREFIX = '[SNACK BAR]';

export const OPEN = `${PREFIX} OPEN`;
export const CLOSE = `${PREFIX} CLOSE`;

export const closeSnackBar = () => ({
  type: CLOSE,
});

export const openSnackBar = (message, isError = false) => ({
  type: OPEN,
  message,
  isError,
});



// WEBPACK FOOTER //
// ./src/store/actions/snackBar.js